module.exports = "<div [class.hide]=\"hideAutomatically && !loadingService.isLoading\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/loading-spinner/loading-spinner.component.html
// module id = m+a3
// module chunks = 5